import { FormValidators, VALIDATION_MESSAGES } from '../../hooks/useForm';
import { ExternalUserShort } from '../../types/externalUser';
import { ROUTINE_TYPES, RoutineExercise, ExerciseDay, ExerciseOrSuperset } from '../../types/Fisiofit/routine';
import { isSuperset, isSingleExercise } from '../../utils/supersetUtils';

const { NOT_NAME, NOT_EXTERNAL_USER, NOT_START_DATE, NOT_EXERCISES, NOT_DURATION } = VALIDATION_MESSAGES;

export interface RoutineForm {
  name?: string;
  exerciseDays: (ExerciseDay & { id?: string })[];
  description?: string;
  localStartDate?: string;
  duration: number | null;
  externalUser?: ExternalUserShort;
  routineType: ROUTINE_TYPES;
}

export const ROUTINE_FORM_VALIDATORS: FormValidators<RoutineForm> = {
  name: (routine) => {
    // A client routine name is generated from the client name and cannot be edited: checking its characters only blocks the routine
    if (!routine.name && routine.routineType !== ROUTINE_TYPES.USER) return NOT_NAME;
    return undefined;
  },
  duration: (routine) => {
    if (routine.routineType === ROUTINE_TYPES.USER && !routine.duration) return NOT_DURATION;
    return undefined;
  },
  externalUser: (routine) => {
    if (routine.routineType === ROUTINE_TYPES.USER && !routine.externalUser) return NOT_EXTERNAL_USER;
    return undefined;
  },
  localStartDate: (routine) => {
    if (routine.routineType === ROUTINE_TYPES.USER && !routine.localStartDate) return NOT_START_DATE;
    return undefined;
  },
  exerciseDays: (routine) => {
    if (!routine.exerciseDays?.length) return NOT_EXERCISES;

    const hasExercises = routine.exerciseDays.every((day) => {
      if (!day?.exercises || !Array.isArray(day.exercises) || day.exercises.length === 0) {
        return false;
      }

      // Validar cada item (ejercicio individual o superserie)
      return day.exercises.every((item) => {
        if (!item) return false;

        if (isSuperset(item as ExerciseOrSuperset)) {
          // Validar que la superserie tenga exactamente 2 ejercicios con exerciseId
          const superset = item as RoutineExercise[];
          return superset.length === 2 && superset.every((exercise) => exercise?.exerciseId);
        }
        // Validar que el ejercicio individual tenga exerciseId
        const exercise = item as RoutineExercise;
        return exercise?.exerciseId;
      });
    });

    if (!hasExercises) return NOT_EXERCISES;
    return undefined;
  },
};
